var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66428 16.1393L8.6125 10.1911L14.5607 16.1393C14.7795 16.358 15.046 16.475 15.35 16.475C15.654 16.475 15.9205 16.358 16.1393 16.1393C16.358 15.9205 16.475 15.654 16.475 15.35C16.475 15.046 16.358 14.7795 16.1393 14.5607L10.1911 8.6125L16.1393 2.66428C16.358 2.44555 16.475 2.17897 16.475 1.875C16.475 1.57103 16.358 1.30445 16.1393 1.08572C15.9205 0.866996 15.654 0.75 15.35 0.75C15.046 0.75 14.7795 0.866995 14.5607 1.08572L8.6125 7.03395L2.66428 1.08572C2.44555 0.866995 2.17897 0.75 1.875 0.75C1.57103 0.75 1.30445 0.866995 1.08572 1.08572C0.866995 1.30445 0.75 1.57103 0.75 1.875C0.75 2.17897 0.866995 2.44555 1.08572 2.66428L7.03395 8.6125L1.08572 14.5607C0.866995 14.7795 0.75 15.046 0.75 15.35C0.75 15.654 0.866996 15.9205 1.08572 16.1393C1.30445 16.358 1.57103 16.475 1.875 16.475C2.17897 16.475 2.44555 16.358 2.66428 16.1393Z",
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconMedium);
export default __webpack_public_path__ + "static/media/closeIconMedium.cfcf2a6d6c05aecc39222b1ce6174418.svg";
export { ForwardRef as ReactComponent };